import ApiService from '@/services/ApiService';
import { serialize } from '@/utils/helper';
export default {
  getCommentList(data){
    const param = serialize(data);
    return ApiService().get(`/comments?${param}`, false, true);
  },
  newComment(data){
    return ApiService().post('/comments', data, true);
  },
  removeComment(key){
    return ApiService().delete(`/comments/${key}`);
  },
  updateComment(data){
    return ApiService().put(`/comments/${data.id}`, data);
  },
  report(data) {
    return ApiService().post(`/comments/report`, data);
  }
};
